const POINT_POSITION = {
  LEFT: 'left',
  RIGHT: 'right',
  DEFAULT: 'center'
};

export { POINT_POSITION };
